export default {
  newDesign: true,
  title: "Çocuğunuz için ücretsiz deneme dersi ayırtın! | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQEG",
    segment: 11,
  },
  startPage: {
    title: "Ücretsiz Deneme Dersi Ayarla!",
    subtitle:
      "Kodlama, matematik veya dijital medya — çocuğunuzun yeteneklerini keşfedin ve geleceğe bir adım atın. 5–17 yaş arası çocuklar için interaktif dersler",
    image: {
      url: "/welcome/turkey_galatasarayfuar_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/turkey_galatasarayfuar_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Hadi başlayalım →",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz için şu anda hangisi daha önemli?",
      subtitle: "Seçiminize göre size en uygun ücretsiz deneme dersini ayarlayalım ✨",
      answers: [
        {
          answer: "💻 Oyun yapımı, programlama veya dijital çizim",
          segment: 11,
        },
        {
          answer: "🧮 Mantık, problem çözme ve oyunla matematik",
          segment: 12,
        },
      ],
    },
    2: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en uygun dersi seçeceğiz.",
      type: "age",
      button: "",
    },
    3: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayır",
          stopAnswer: true,
        },
      ],
    },
    4: {
      title: "🎉 Sadece bir adım kaldı!",
      typeInfo: "congrats",
      subtitle:
        "Çocuğunuza özel ücretsiz deneme dersi için yerinizi ayırtın.\n\n🌟 200.000'den fazla çocuk bizimle birlikte üretiyor ve öğreniyor.",
      button: "📅 Ücretsiz bir ders ayırtın!",
    },
    5: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    6: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    7: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    8: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    9: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
